import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart, MapPin } from "lucide-react";
import { imgSrc } from "@/lib/api";

export const AnimalCard = ({ animal, featured = false }) => (
  <motion.article
    initial={{ opacity: 0, y: 48 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.85, ease: [0.16, 1, 0.3, 1] }}
    className={featured ? "md:col-span-8 md:row-span-2" : "md:col-span-4"}
  >
    <Link
      to={`/animal/${animal.post_id}`}
      data-testid={`animal-card-${animal.post_id}`}
      className="group flex h-full flex-col border border-border bg-card transition-colors duration-500 hover:border-foreground/40"
    >
      <div className={`relative overflow-hidden ${featured ? "h-80 md:min-h-[480px] md:flex-1" : "h-64"}`}>
        <img
          src={imgSrc(animal.image_url)}
          alt={animal.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]"
        />
        <div className="absolute inset-0 bg-black/0 transition-colors duration-500 group-hover:bg-black/15" />
        <span className="absolute left-0 top-0 bg-background/85 px-3 py-1.5 text-[10px] font-bold uppercase tracking-[0.2em] backdrop-blur-md">
          {animal.category}
        </span>
      </div>
      <div className="p-6">
        <h3
          data-testid={`animal-card-title-${animal.post_id}`}
          className={`font-serif font-semibold leading-none tracking-tight ${featured ? "text-3xl md:text-4xl" : "text-2xl"}`}
        >
          {animal.title}
        </h3>
        <p className="mt-2 font-serif text-base italic text-muted-foreground">{animal.species}</p>
        <div className="mt-5 flex items-center justify-between text-xs text-muted-foreground">
          <span className="flex items-center gap-1.5">
            <MapPin className="h-3.5 w-3.5 text-primary" />
            {animal.location_name}
          </span>
          <span className="flex items-center gap-1.5">
            <Heart className="h-3.5 w-3.5 text-primary" />
            {animal.likes_count}
          </span>
        </div>
      </div>
    </Link>
  </motion.article>
);
